import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import screenAndStyle from '../_utils/screen-and-style';
import { calculateDimensions } from '../_utils/tools/image-tools';
import Spinner from '../_utils/spinner';

const maskSrc = (isScalloped, portrait) => {
  const edge = isScalloped ? 'scallop' : 'elegant';
  const orientation = portrait ? 'portrait' : 'landscape';
  const ext =
    screenAndStyle.isSafari() || screenAndStyle.isEdge() ? '.png' : '.svg';

  return `/stylesheets/walmart/images/scalloped_edges_and_elegant_corners/5x7_${edge}_mask_${orientation}${ext}`;
};

const RenderNormal = ({ url, alt, isCard, isRounded, isShadow, dimensions, onLoad }) => {
  const { width, height } = dimensions;

  return (
    <div className="product-image mx-auto">
      <img
        className={classNames('img-fluid lazyload image', {
          'card-shadow': isCard && isShadow,
          'rounded-corners': isRounded,
        })}
        src={url}
        data-src={url}
        alt={alt}
        width={width}
        height={height}
        onLoad={onLoad}
      />
    </div>
  );
};

const RenderMasked = ({ portrait, isScalloped, url }) => {
  const getPortraitDimensions = () => {
    return portrait
      ? { paddingTop: '97%', width: '71.5%' }
      : { paddingTop: '71.5%', width: '100%' };
  };

  const { paddingTop, width } = getPortraitDimensions();
  const maskedSrc = maskSrc(isScalloped, portrait);

  return (
    <div
      className="product-image corners-product-image mx-auto"
      data-test-id="masked-image"
      style={{
        backgroundImage: `url(${maskedSrc}), url(${url})`,
        paddingTop,
        width,
      }}
    />
  );
};
const RenderCustomisationOverlay = ({ url, optionAsset }) => {
  return (
    <div
      className="product-image corners-product-image mx-auto"
      data-test-id="masked-image"
      style={{
        backgroundImage: `url(${optionAsset}), url(${url})`,
        paddingTop: '100%',
        width: '100%',
      }}
    />
  );
};
const ProductImage = ({
  index,
  url,
  alt,
  isCard,
  isRounded,
  isElegant,
  isScalloped,
  isSquare,
  optionAsset,
  isMobile,
}) => {
  const isShadow = isSquare;
  const [dimensions, setDimensions] = useState({ height: 0, width: 0 });
  const [loaded, setLoaded] = useState(false);
  const [portrait, setPortrait] = useState(false);
  let mounted = false;

  useEffect(() => {
    mounted = true;

    if (!loaded) {
      updateImageDimensions(url);
    }

    return () => {
      mounted = false;
    };
  }, [loaded, url]);

  const updateImageDimensions = (url) => {
    calculateDimensions(url)
      .then(({ height, width }) => {
        if (mounted) {
          setDimensions({ height, width });
          setLoaded(true);
          setPortrait(height > width);
        }
      })
      .catch(() => {
        if (mounted) {
          setLoaded(false);
        }
      });
  };

  const renderTemplate = () => {
    if (optionAsset) {
      return <RenderCustomisationOverlay url={url} optionAsset={optionAsset} />;
    } else if (isElegant || isScalloped) {
      return (
        <RenderMasked portrait={portrait} isScalloped={isScalloped} url={url} />
      );
    } else {
      return (
        <RenderNormal
          url={url}
          alt={alt}
          isCard={isCard}
          isRounded={isRounded}
          isShadow={isShadow}
          dimensions={dimensions}
          onLoad={() => updateImageDimensions(url)}
        />
      );
    }
  };

  if (loaded) {
    return renderTemplate();
  } else {
    if (isMobile) {
      // show one spinner for mobile view while loading
      if (index === 0) return <Spinner />;
    } else {
      return <Spinner />;
    }
  }
};

export default ProductImage;
